export default "__VITE_PUBLIC_ASSET__50718612__"